export default __webpack_public_path__ + "static/step_thumb-ce7b22805c751b7736f0ab56afdc7bf9.png";